import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { EnvironmentServiceProvider } from './../environment-service/environment-service';

@Injectable()
export class ClientPlanServiceProvider {

  constructor(
    public http: HttpClient,
    public envService: EnvironmentServiceProvider
    ) {}

  getClientPlans(cp): Observable<any>{
    let membersParams = new HttpParams().append('clientPlanId', cp.toString())

    return this.http.get(this.envService.env.apiEndpoint + '/smp/cp/clientPlans/v1', {
      params: membersParams, observe: 'response'
    })
  }

  // getSignatures(s): Observable<any>{
  //   let membersParams = new HttpParams().append('tripNumber', s.toString())

  //   return this.http.get(this.envService.env.apiEndpoint + '/smp/cp/clientPlans/v1/signatures', {
  //     params: membersParams, observe: 'response'
  //   })
  // }

}



// WEBPACK FOOTER //
// ./src/providers/client-plan-service/client-plan-service.ts